import React from "react";
import GeotabBadge from "./GeotabBadge.jsx";
import { Hint } from "./GeotabHover.jsx";
import { impactLabel } from "./geotabFindings.js";
import { deltaTone } from "./geotabFormat.js";

const toneOf = (item, tolerance) => item.tone && item.impact == null ? item.tone : item.tone === "off" ? "off" : deltaTone(item.impact, tolerance);

function Line({ item, tolerance, strong = false }) {
  return (
    <li className="flex items-start gap-2 border-t border-slate-100 py-1 first:border-t-0">
      <span className="mt-px w-16 shrink-0"><GeotabBadge tone={toneOf(item, tolerance)}>{impactLabel(item)}</GeotabBadge></span>
      <span className="min-w-0 text-[12px] leading-snug [overflow-wrap:anywhere]">
        <b className={strong ? "text-[12.5px] text-slate-900" : "font-semibold text-slate-800"}>{item.title}</b>
        <span className="block text-slate-500">{item.detail}</span>
      </span>
    </li>
  );
}

// Option A : les 3 constats qui coûtent le plus en tête, le reste replié.
export function FindingsPanel({ title, items, tolerance }) {
  const top = items.slice(0, 3);
  const rest = items.slice(3);
  return (
    <section className="min-w-0 rounded-[4px] border border-slate-200 bg-white px-3 py-1.5">
      <div className="truncate text-[12.5px] font-bold text-slate-800">{title}</div>
      {items.length === 0 ? <p className="mt-1 text-[12px] text-slate-500">Aucun écart au-delà de la tolérance.</p> : (
        <>
          <div className="mt-1 rounded-[4px] border border-slate-200 bg-white px-2 py-1 shadow-[inset_3px_0_0_#c5524a]">
            <div className="text-[10px] font-black uppercase tracking-[0.08em] text-[#c5524a]">À retenir</div>
            <ul className="m-0 list-none p-0">{top.map((item, i) => <Line key={i} item={item} tolerance={tolerance} strong />)}</ul>
          </div>
          {rest.length > 0 && (
            <details className="mt-1">
              <summary className="cursor-pointer text-[11.5px] font-bold text-slate-600">Autres constats ({rest.length})</summary>
              <ul className="m-0 list-none p-0">{rest.map((item, i) => <Line key={i} item={item} tolerance={tolerance} />)}</ul>
            </details>
          )}
        </>
      )}
    </section>
  );
}

// Constats de la journée : une ligne chacun, le détail complet au survol.
export function DayFindings({ items, tolerance }) {
  return (
    <section className="min-w-0 rounded-[4px] border border-slate-200 bg-white px-3 py-1.5">
      <div className="text-[12.5px] font-bold text-slate-800">Constats de la journée</div>
      {items.length === 0 ? <p className="mt-1 text-[12px] text-slate-500">Rien de plus que les indicateurs du haut.</p> : (
        <ul className="m-0 mt-0.5 list-none p-0">
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-2 border-t border-slate-100 py-1 first:border-t-0">
              <span className="w-16 shrink-0"><GeotabBadge tone={toneOf(item, tolerance)}>{impactLabel(item)}</GeotabBadge></span>
              <Hint text={item.detail}>
                <span className="min-w-0 truncate text-[12px]"><b className="font-semibold text-slate-800">{item.title}</b> <span className="text-slate-500">· {item.detail}</span></span>
              </Hint>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
